import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import guLocale from "../locales/gu";
import { useNavigate, Link } from "react-router-dom"; // Import useNavigate
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../context/AuthContext";

const PricingPage = ({ handleCheckout, plans }) => {
  const locale = guLocale.pricing;
  const { logout } = useAuth();
  const navigate = useNavigate(); // Initialize useNavigate

  const handleGoBack = () => {
    navigate("/dashboard"); // Navigate back one page
  };

  const handleLogout = async () => {
    logout();
    navigate("/login");
  };
  return (
    <div
      style={{
        background: "#e9ecef",
        minHeight: "100vh",
      }}
    >
      <nav
        className="main-header navbar navbar-expand navbar-white navbar-light custom-navbar"
        style={{ marginLeft: "0px" }}
      >
        <Link className="navbar-brand custom-brand">
          <img
            src="../dist/img/logos/dark-logo-6.png"
            alt="Easy Rojmel"
            className="brand-image custom-logo"
          />
        </Link>
        <div className="custom-nav-container">
          <ul className="navbar-nav custom-nav">
            <li className="nav-item logout-item">
                <button className="logout-button" onClick={handleLogout}>
                    <i className="nav-icon fas fa-sign-out-alt"></i> લૉગ આઉટ
                </button>
            </li>
          </ul>
        </div>
      </nav>
      <Container>
        <div
          style={{
            display: "flex",
            alignItems: "baseline",
            marginBottom: "20px",
            marginTop: "10px",
          }}
        >
          <button
            onClick={handleGoBack}
            style={{
              background: "none",
              border: "none",
              fontSize: "2.5rem",
              cursor: "pointer",
              padding: "0",
              marginRight: "10px",
              color: "#007bff",
            }}
          >
            <FontAwesomeIcon icon={faArrowLeft} className="me-2" />{" "}
            {locale.back}
          </button>
          <h2
            className="text-center mb-5 fw-bold"
            style={{ fontSize: "2.5rem", color: "#333", margin: "0 auto" }}
          >
            {locale.title}
          </h2>
        </div>
        <Row className="justify-content-center">
          {plans.map((plan, index) => (
            <Col md={4} className="mb-4 mx-3 d-flex" key={index}>
              <Card
                className="shadow-lg border-0 flex-fill"
                style={{
                  backgroundColor: "#ffffff",
                  borderRadius: "10px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Card.Body
                  style={{
                    padding: "25px",
                    textAlign: "left",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div style={{ marginBottom: "20px" }}>
                    <h6
                      className="text-muted mb-2"
                      style={{
                        fontWeight: "bold",
                        color: "#777",
                        fontSize: "0.9rem",
                      }}
                    >
                      {locale.financialYear}
                    </h6>
                    <h5
                      className="fw-bold"
                      style={{
                        fontSize: "1.3rem",
                        marginBottom: "10px",
                        color: "#555",
                      }}
                    >
                      {plan.plan_name}
                    </h5>
                    <h3
                      className="text-primary"
                      style={{ fontSize: "2.2rem", marginBottom: "15px" }}
                    >
                      ₹{plan.amount}
                    </h3>
                    <p
                      style={{
                        color: "#777",
                        marginBottom: "20px",
                        fontSize: "1rem",
                      }}
                    >
                      {plan.description}
                    </p>
                  </div>
                  <ul className="list-unstyled flex-grow-1">
                    <li>
                      <span style={{ color: "green", marginRight: "5px" }}>
                        ✓
                      </span>{" "}
                      કેશબુક રિપોર્ટ
                    </li>
                    <li>
                      <span style={{ color: "green", marginRight: "5px" }}>
                        ✓
                      </span>{" "}
                      ખાતાવહી
                    </li>
                    <li>
                      <span style={{ color: "green", marginRight: "5px" }}>
                        ✓
                      </span>{" "}
                      પરિશિષ્ટ 9
                    </li>
                    <li>
                      <span style={{ color: "green", marginRight: "5px" }}>
                        ✓
                      </span>{" "}
                      પરિશિષ્ટ 10
                    </li>
                    <li>
                      <span style={{ color: "green", marginRight: "5px" }}>
                        ✓
                      </span>{" "}
                      બિલ રજિસ્ટર
                    </li>
                    <li>
                      <span style={{ color: "green", marginRight: "5px" }}>
                        ✓
                      </span>{" "}
                      ચેક રજિસ્ટર
                    </li>
                    <li>
                      <span style={{ color: "green", marginRight: "5px" }}>
                        ✓
                      </span>{" "}
                      ગ્રાન્ટ રજિસ્ટર
                    </li>
                  </ul>
                  <Button
                    variant="primary"
                    className="w-100"
                    onClick={() => handleCheckout(plan)}
                    disabled={plan.isPurchased}
                  >
                    {plan.isPurchased
                      ? locale.alreadySubscribed
                      : locale.subscribe}
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default PricingPage;
